import { render, staticRenderFns } from "./circleDetail.vue?vue&type=template&id=24881538&scoped=true&"
import script from "./circleDetail.vue?vue&type=script&lang=js&"
export * from "./circleDetail.vue?vue&type=script&lang=js&"
import style0 from "./circleDetail.vue?vue&type=style&index=0&id=24881538&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24881538",
  null
  
)

export default component.exports